import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Col, Radio, Row } from "antd";
import useModalHandler from "utils/useModalHandler";
import UploadModal from "components/UploadModal";
import { downloadExcel, downloadExcelNameCode } from "service/score";
import { importCustomGrade } from "service/score";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import LoadingModal from "components/LoadingModal";

const Index = ({
    courseNo,
    courseSeq,
    refreshData,
    handelResultVisible
}: {
    courseNo: string;
    courseSeq: string;
    refreshData: () => void;
    handelResultVisible: () => void; //打开结果页面
}) => {
    const uploadExcelModal = useModalHandler();
    const [weight, setWeight] = useState<"0" | "1">("1"); //是否带权重0否1是
    const [loading, setLoading] = useState(false);

    const onUploadOk = async (file?: File) => {
        if (!file) return;
        uploadExcelModal.close(); //批量导入弹窗关闭
        setLoading(true);

        try {
            await importCustomGrade(file, courseNo, courseSeq, weight);
            await refreshData();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        } finally {
            setLoading(false);
            handelResultVisible();
        }
    };

    return (
        <>
            <Button type="primary" ghost onClick={uploadExcelModal.open}>
                导入成绩
            </Button>

            {uploadExcelModal.render(
                <UploadModal
                    onUploadOk={onUploadOk}
                    onCancel={uploadExcelModal.close}
                    title="导入成绩">
                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            1.导入规则设置
                            <span className={style.info}>
                                （仅支持1位小数，多余位数将四舍五入，可能存在偏差）
                            </span>
                        </Col>
                    </Row>
                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            <Radio.Group
                                value={weight}
                                onChange={e => setWeight(e.target.value)}>
                                <Radio value="1">导入百分制成绩</Radio>
                                <Radio value="0">导入按权重折算后成绩</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row className={style.row}>
                        <Col className={style.label}>
                            2. 下载
                            <Button
                                className={style.link}
                                type="link"
                                onClick={() =>
                                    downloadExcel(courseNo, courseSeq)
                                }>
                                《导入自定义项成绩模板》
                            </Button>
                            &nbsp;或
                            <Button
                                className={style.link}
                                type="link"
                                onClick={() =>
                                    downloadExcelNameCode(courseNo, courseSeq)
                                }>
                                《导入自定义项成绩模板》(带学号姓名)
                            </Button>
                        </Col>
                    </Row>

                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            <i className={style.required}>*</i>
                            3.在导入模板补充好成绩数据后上传文件
                        </Col>
                    </Row>
                </UploadModal>
            )}

            <LoadingModal
                title="导入成绩中..."
                content="若离开当前界面或退出系统，导入处理仍在继续，将任务完成后，您可在当前界面下载导入结果。"
                visible={loading}
                onCancel={() => setLoading(false)}
            />
        </>
    );
};

export default Index;
